'use client';

import React from 'react';
import { Box } from '@shopify/polaris';
import { MediaAssetProviders } from '@/features/ai-video-creator/stores/productMediaSlice';
import { useSocialMediaPreviewQuery } from '../media-modal/hooks/useSocialMediaPreviewQuery';
import { MediaType } from '@/api/social-media';

type ProviderConnectorAssetsPreviewProps = {
  provider: MediaAssetProviders;
  type?: MediaType.image | MediaType.video;
};

export const ProviderConnectorAssetsPreview = ({ provider, type }: ProviderConnectorAssetsPreviewProps) => {
  const { assets, isLoading } = useSocialMediaPreviewQuery({
    provider,
    type: type || MediaType.video,
  });

  return (
    <Box>
      {!isLoading && (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {assets.map((asset, index) => (
            <Box
              key={asset.id || index}
              borderWidth="100"
              borderStyle="solid"
              borderColor="transparent"
              borderRadius="200"
            >
              <div className="relative aspect-square h-full">
                <img
                  src={asset.previewImage || ''}
                  alt={`${asset.type.charAt(0).toUpperCase() + asset.type.slice(1)} ${index + 1}`}
                  className="h-full w-full rounded-[var(--p-border-radius-100)] object-cover blur"
                />
              </div>
            </Box>
          ))}
        </div>
      )}
    </Box>
  );
};
